<template>
  <div class="main">
    <c-panel title="Veículos" titleIcon="fas fa-bus">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

